import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import {BaseComponent, Option} from 'nc-shared';
import {filter, takeUntil} from 'rxjs/operators';
import {StringsUtils} from 'nc-utils';

@Component({
  selector: 'nc-document-form',
  templateUrl: './nc-document-form.component.html',
  styleUrls: ['./nc-document-form.component.scss']
})
export class NcDocumentFormComponent extends BaseComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() documentTypes$: Observable<Array<Option>>;
  @Input() fileUploadId: string;
  @Input() inputId: string;
  @Input() selectId: string;
  @Input() selectSearchTextId: string;
  @Input() selectSearchButtonId: string;
  @Input() selectClearIconId: string;

  isNewDocument: boolean;

  constructor() {
    super();
  }

  ngOnInit(): void {
    const fileControl = this.formGroup.get('file') as FormControl;
    const nameControl = this.formGroup.get('name') as FormControl;
    this.isNewDocument = StringsUtils.isEmpty(nameControl.value);

    nameControl.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(name => {
      const extension = this.formGroup.get('extension').value;
      this.formGroup.get('nameWithExtension').setValue(`${name}.${extension}`);
    });

    fileControl.valueChanges.pipe(
      takeUntil(this.destroy$),
      filter(files => !nameControl.value && files)
    ).subscribe(files => {
      const file = files.files[0];
      if (!nameControl.value) {
        nameControl.patchValue(this.getNameWithoutExtension(file.name));
        nameControl.markAsTouched();
      }

      this.formGroup.get('nameWithExtension').patchValue(file.name);
      this.formGroup.get('extension').patchValue(this.getExtension(file.name));
    });
  }

  private getNameWithoutExtension = fileName => fileName.split('.').slice(0, -1).join('.');
  private getExtension = fileName => fileName.split('.').pop();
}
